import styled, { css, keyframes } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

const highlightFade = keyframes`
    from {
        background-color: ${colorsPalettes.blue[100]};
    }
    to {
        background-color: ${colorsPalettes.carbon[0]};
    }
`;

export const StyledContactCard = styled.div<{ isDisabled: boolean; isHighlighted?: boolean }>`
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    padding: 8px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    box-shadow: 0 3px 6px 0 #0e1e3e14;
    border: 1px solid transparent;
    max-width: 196px;
    min-width: 196px;
    box-sizing: border-box;
    min-height: 58px;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

    ${({ isDisabled }) =>
        isDisabled
            ? css`
                  background-color: ${colorsPalettes.bluegrey[200]};
                  box-shadow: none;
                  border: 1px solid ${colorsPalettes.midnight[50]};
              `
            : css`
                  &:hover {
                      border: 1px solid ${colorsPalettes.carbon[100]};
                  }
              `}

    ${({ isHighlighted }) =>
        isHighlighted &&
        css`
            animation: ${highlightFade} 2s ease-out;
        `}

    ${SWReactIcons} {
        display: flex;
    }
`;
